<template>
  <div class="wrapper">
    <img
      v-if="!erroNaImagem"
      :src="imagem"
      class="aviso"
      alt="Sistema congelado"
      @error="erroNaImagem = true"
    />
    <div v-else class="fallback">
      <img src="/img/logo.png" width="120" class="mb-6" />
      <h1>Sistema encontra-se congelado</h1>
      <p>Para mais informações, entre em contato com o seu gestor.</p>
      <p>Atenciosamente, Equipe - Caju Tec</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuspensaoPage",
  data() {
    return {
      imagem: "/img/congelamento.jpeg",
      erroNaImagem: false,
    };
  },
};
</script>

<style scoped>
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
}

.aviso {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.fallback {
  text-align: center;
  padding: 24px;
  max-width: 620px;
}

.fallback > h1 {
  font-size: 1.6rem;
  margin-bottom: 12px;
}

.fallback > p {
  color: rgba(0, 0, 0, 0.6);
}
</style>
